/* @flow */
import axios from 'axios'
import oPath from 'object-path'
import {NEW_NOTIFICATION} from '@/store/notifications'
import {formatTimestamp, dateDifferenceInWords} from '@/utils/date'
import {addDays} from 'date-fns'

export const CREATE_SESSION = 'CREATE_SESSION'
export const NEW_SESSION = 'NEW_SESSION'
export const NEW_SESSION_FROM_META_OBJECT = 'NEW_SESSION_FROM_META_OBJECT'
export const UPDATE_SESSION = 'UPDATE_SESSION'
export const REMOVE_SESSION = 'REMOVE_SESSION'

const initialState = () => ({
  user: {
    id: '',
  },
  organization: {
    id: '',
  },
  authToken: '',
  expiresAt: '',
  passwordExpiration: ''
})

export default {
  state: initialState(),
  getters: {
    currentUser: (state: Object) => state.user || {},
    currentOrganization: (state: Object) => state.organization || {},
  },
  mutations: {
    [UPDATE_SESSION](state: Object, payload: Object) {
      if (payload.user) {
        state.user = {
          ...state.user,
          ...payload.user,
        }
      }
      if (payload.organization) {
        state.organization = {
          ...state.organization,
          ...payload.organization,
        }
      }
      if (payload.authToken) {
        state.authToken = payload.authToken
        axios.defaults.headers.common['X-AUTH-TOKEN'] = payload.authToken
      }
      if (payload.expiresAt) {
        state.expiresAt = payload.expiresAt
      }
      if (payload.passwordExpiration) {
        state.passwordExpiration = payload.passwordExpiration
      }
    },
    [REMOVE_SESSION](state: Object) {
      // Remove everything except for user id so we can use user id on login to determine
      // whether all state needs reset or not
      axios.delete('/sessions?data=1')
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        // eslint-disable-next-line
        console.error(error)
      })
      Object.assign(state, initialState(), {user: {id: state.user.id}})
      axios.defaults.headers.common['X-AUTH-TOKEN'] = undefined
    },
  },
  actions: {
    [NEW_SESSION]: async function({commit, state}: Object, payload: Object) {
      if (payload.user.id !== state.user.id) {
        commit('RESET_STATE', null, {root: true})
      }
      commit(UPDATE_SESSION, payload)
    },
    [NEW_SESSION_FROM_META_OBJECT]: async function({dispatch}: Object, payload: Object) {
      await dispatch(NEW_SESSION, {
        user: {
          id: payload.user_id,
        },
        organization: {
          id: payload.organization_id,
        },
        authToken: payload.auth_token,
        expiresAt: payload.expires_at,
        passwordExpiration: payload.password_expiration
      })
      var today = new Date()
      var nextWeek = addDays(today,7)
      var fewWeeks = addDays(today,21)
      // var nextMonth = addDays(today,30)
      var expirationDate = payload.password_expiration == null ? 
        new Date(2200,1,1) : 
        new Date(payload.password_expiration)
      // console.log( "today: " + today + " nextWeek: " + nextWeek + "few weeks: " + fewWeeks + " next Month: " + nextMonth + " expiration Date: " + expirationDate)
      if( expirationDate < nextWeek ) {
        const daydiff = dateDifferenceInWords(expirationDate)
        await dispatch(NEW_NOTIFICATION, {
          text: `ALERT: Password Expires ${daydiff}.`,
          link:['Change password','/me'],
          color: 'error'
        })
      }
      else if (expirationDate < fewWeeks ) {
        const daydiff = dateDifferenceInWords(expirationDate)
        await dispatch(NEW_NOTIFICATION, {
          text: `WARNING: Password Expires ${daydiff}.`,
          link:['Change password','/me'],
          color: 'warning'
        })
      }
      // don't warn the user 1 month early that their password is expiring
      // else if (expirationDate < nextMonth) {
      //   await dispatch(NEW_NOTIFICATION, {
      //     text: 'Early Notification: Password Expires',
      //     detail: formatTimestamp(payload.password_expiration),
      //     color: 'info'
      //   })
      // }
    },
    [CREATE_SESSION]: async function({dispatch}: Object, payload: Object) {
      try {
        const {
          data: {meta},
        } = await axios.post('/sessions', {
          meta: {
            email: payload.email,
            password: payload.password,
            mfa_code: payload.mfa_code
          },
        })
        if (meta.google_mfa) {
          return {meta}
        } else if (!meta.auth_token) {
          throw new Error('No auth_token')
        }
        await dispatch(NEW_SESSION_FROM_META_OBJECT, meta)
        return { success: true }
      } catch (error) {
        const detail = oPath.get(error, 'response.data.errors.0.detail')
        const rpt = oPath.get(error, 'response.data.errors.0.reset_password_token')

        if (
          detail &&
          (detail.includes('password invalid') || detail.includes('not found'))
        ) {
          return {error: 'Email or password is incorrect.'}
        } else if( rpt ) {
          return {
            error: `Login failed: '${
              error.message
            }'`,
            reset_password_token: rpt
          }
        } else {
          return {
            error: `Login failed: '${
              error.message
            }'`,
          }
        }
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/session.js